import React from 'react'
import PasswordChange from '../../components/common/PasswordChange'

export default function AdminPasswordChange() {
    return (
        <PasswordChange />
    )
}
